module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"accessToFullVideo":"Video","presentation":"Download presentation","speaker":"Speaker | Speakers"}}')
  delete Component.options._Ctor
}
